export const SITE = {
  phone: "+91 8143637343",
  phoneHref: "tel:+918143637343",
  whatsapp: "https://wa.me/8143637343",
  email: "info@smtinstitute.com",
  address: "Hyderabad, Telangana, India",
  hours: "Mon–Sat · 9:00 AM – 7:00 PM",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=1280&q=80";

export const BANNER_IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=1600&q=80",
    alt: "Mobile repair technician working on a smartphone motherboard",
  },
  {
    src: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1600&q=80",
    alt: "Close-up of smartphone components and repair tools",
  },
  {
    src: "https://images.unsplash.com/photo-1556656793-08538906a9f8?auto=format&fit=crop&w=1600&q=80",
    alt: "Students learning mobile repair in a training lab",
  },
  {
    src: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=1600&q=80",
    alt: "Modern smartphones displayed for repair training",
  },
];
